import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const Ai_traning_Data = createAsyncThunk(
  "community/Ai_traning_Data",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("community/ai-training", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const Ai_traning_Data_update = createAsyncThunk(
  "community/Ai_traning_Data",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("community/ai-training", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchAllAiTrainingData = createAsyncThunk(
  "community/fetchAllAiTrainingData",
  async ({ page, page_size,searchQuery }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("community/ai-training",{
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteAiTrainingData = createAsyncThunk(
  "community/deleteAiTrainingData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/community/ai-training/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


